<template>
<a-spin :spinning="spinning" tip="Loading...">
    <div class="card mb-3">
        <img style="display: none;" id='logobarter' :src="imagepath" alt='logobarter' crossorigin="anonymous">
        <div class="row no-gutters">
            <div class="col-md-12" style="border-right: 1px solid #e0e0e0">
                <div class="card-body">
                    <div class="row">
                        <div class="col-md-7">
                            <div class="row">
                                <div class="col-md-7">
                                    <base-input alternative="" label="As of"><br>
                                        <a-date-picker v-model="inputDate" format="MM-DD-YYYY" placeholder="Start Date" :disabled="true" style="width:100%"/>
                                    </base-input>
                                </div>
                            </div>
        
                            <div class="row">
                                <div class="col-md-7">
                                    <base-input alternative="" label="Select Site">
                                        <a-select mode="multiple" v-model="inputSite" showSearch placeholder="All Sites" optionFilterProp="children" style="width: 100%" :filterOption="filterOption" :disabled="site_type != 'ho'">
                                            <a-select-option v-for="option in siteOptions" :key="option.id" :value="option.id">{{option.name}}</a-select-option>
                                        </a-select>
                                    </base-input>
                                </div>
                            </div>
        
                            <div class="row">
                                <div class="col-md-7">
                                    <base-input alternative="" label="Status">
                                        <a-select v-model="inputStatus" showSearch optionFilterProp="children" style="width: 100%" :filterOption="filterOption">
                                            <a-select-option v-for="option in statusOptions" :key="option.id" :value="option.id">{{option.name}}</a-select-option>
                                        </a-select>
                                    </base-input>
                                </div>
                            </div>
        
                             <div class="row" v-if="inputStatus == 2">
                                <div class="col-md-7">
                                    <base-input alternative="" label="Days to Expire" :disabled='isDaysVisible'>
                                        <a-input v-if="isDaysVisible" type="number" class="mb-1" v-model="daysToExpire" placeholder="Days" />
                                    </base-input>
                                </div>
                            </div>
                            
                            <div class="row">
                                <div class="col-md-7">
                                    <base-input alternative="" label="Order By">
                                        <a-select v-model="inputOrderBy" showSearch optionFilterProp="children" style="width: 100%" :filterOption="filterOption">
                                            <a-select-option v-for="option in orderOptions" :key="option.id" :value="option.id">{{option.name}}</a-select-option>
                                        </a-select>
                                    </base-input>
                                </div>
                            </div>
        
                            <div class="row">
                                <div class="col-md-7">
                                    <base-input alternative="" label="Group By">
                                        <a-select v-model="inputGroupBy" showSearch optionFilterProp="children" style="width: 100%" :filterOption="filterOption">
                                            <a-select-option v-for="option in groupOptions" :key="option.id" :value="option.id">{{option.name}}</a-select-option>
                                        </a-select>
                                    </base-input>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-4 align-self-center">
                            <div v-if="reportDescription != ''" class="card">
                                <div class="card-body">
                                    <div class="card-text">
                                        {{ reportDescription }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>


                    <div class="row">
                        <div class="col-md-12">
                            <br>
                            <button class="btn btn-sm btn-default float-right" style="border-radius: 24px; border:0px; width: 20%;" @click.prevent="generateReport">Generate Report in PDF</button> &nbsp; &nbsp;
                            <button v-if="JsonData.length < 1" class="btn btn-sm btn-default float-right" style="border-radius: 24px; border:0px; width: 20%;" @click.prevent="generateFile">Generate Report</button> &nbsp; &nbsp;
                            <vue-json-to-csv v-if="JsonData.length > 0" :show-labels="false" :json-data="JsonData" :csv-title="currentProfile.replace(/_/g, '-')+'-'+currDate.replace(/ /g, '_')">
                                <button id='clickCsvExport' class="btn btn-sm btn-success float-right" style="border-radius: 24px; border:0px; width: 20%;"> Download CSV </button> &nbsp; &nbsp;
                            </vue-json-to-csv>
                            <button v-if="JsonData.length > 0" class="btn btn-sm btn-success float-right" style="border-radius: 24px; border:0px; width: 20%%;" @click.prevent="generateExcel"> Download Excel</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</a-spin>
</template>

<script>
    import HTTPRequest from '../../controllers/httpRequest.js'
    import secureStorage from '../../controllers/secureStorage';
    import reportUtils from '../../components/reportUtils'
    import moment from 'moment';
    import jsPDF from 'jspdf';
    import 'jspdf-autotable';
    import VueJsonToCsv from 'vue-json-to-csv';
    import * as ExcelJS from "exceljs";
    import { saveAs } from "file-saver";
    import { getReportDescription } from '../../utilities';
    import {
        mapState
    } from 'vuex'

    export default {
        data() {
            return {
                imagepath: secureStorage.getItem("account_logo"),
                isDaysVisible: true,
                daysToExpire: '',
                filterStatus: '0',
                spinning: false,
                inputDate: moment().endOf('day'),
                currDate: moment().format("L_LT").split(":").join(";"),
                inputStatus: 1,
                inputSite: [],
                inputOrderBy: "expired_at",
                inputGroupBy: "s.id",
                site_type: "ho",
                siteOptions: [],
                orderOptions: [
                        {"id" : "expired_at", "name": "Expiry Date"},
                        {"id" : "pi.name", "name": "Name"},
                        {"id" : "i.lotcode", "name": "Lot Code"},
                        {"id" : "pi.stock_no", "name": "Stock No"},
                        {"id" : "pi.barcode", "name": "Barcode"}],
                groupOptions: [
                        {"id" : "s.id", "name": "Supplier"},
                        {"id" : "b.id", "name": "Brand"},
                        {"id" : "c.id", "name": "Category"}],
                statusOptions: [
                        {"id" : 1, "name": "All"},
                        {"id" : 2, "name": "Near Expiry"},
                        {"id" : 3, "name": "Expired"}],
                birSalesReports: [],
                JsonData: []
            }
        },
        mounted: async function () {
            var component_x = this;

            var userId = secureStorage.getItem("userId")
            var sites = await HTTPRequest.getRequest(component_x.endPoint + "sites/get_valid_sites?user_id=" + userId, null);
            component_x.siteOptions = sites;
            component_x.sort(component_x.siteOptions);

            let siteId = secureStorage.getItem("defaultSiteId")
            this.inputSite = [siteId]
            this.reportDescription = await getReportDescription(this.currentProfile)
            let site = await HTTPRequest.getRequest(this.endPoint + "/sites/" + siteId, null)
            if(site != undefined){
                this.site_type = site.site_type
            }
        },
        computed: {
            ...mapState(['currentProfile', 'currentApiURL', 'endPoint', 'parameters']),
        },
        components:{
            VueJsonToCsv
        },
        watch: {
        // inputStatus: function () {
        //     this.isDaysVisible = (this.inputStatus == '1' || this.inputStatus == '2') ? true : false;
        // }
        },
        methods: {
            moment,
            filterOption(input, option) {
                return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
            },
            sort(data){
                data.sort(function (a, b) {
                    return a.name.localeCompare(b.name);
                });
            },
            convertToCurrency(num){
                return num.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
            },
            openNotificationWithIcon(type, msg) {
                this.$notification[type]({
                    message: 'Export Error',
                    description: msg 
                });
            },
            isJsonString(str) {
                try {
                    var json = JSON.parse(str);
                    return (typeof json === 'object');
                } catch (e) {
                    return false;
                }
            },
            generateReport: async function () {
                this.spinning= true;
                let as_of_date_from = this.inputDate.format('YYYY-MM-DD HH:mm:ss');
                let as_of_date_to = this.inputDate.format('YYYY-MM-DD HH:mm:ss');
                let group_by = ((this.inputGroupBy == 's.id') ? 'Supplier' : (this.inputGroupBy == 'b.id') ? 'Brand' : 'Category' );

                if([2].includes(this.inputStatus) && Number(this.daysToExpire) < 1){
                    this.openNotificationWithIcon('error', 'Days to expire is required.');
                    this.spinning= false;
                    return
                }

                if([2].includes(this.inputStatus))
                     as_of_date_to = moment(this.inputDate).add(this.daysToExpire, 'd').format('YYYY-MM-DD HH:mm:ss')
                
                var get_request = await HTTPRequest.getRequest(this.endPoint + 'product_expiration_report?site_id=' + this.inputSite + '&status=' + this.inputStatus + '&as_of_date_to=' + as_of_date_to + '&as_of_date_from=' + as_of_date_from + '&days_to_expire=' + this.daysToExpire + '&order_by=' + this.inputOrderBy + '&group_by=' + this.inputGroupBy, null);

                let reportLogo = document.getElementById('reportLogo');

                var siteSpecific = get_request;
                if(siteSpecific.length > 0){
                    let doc = new jsPDF({ orientation: 'portrait', unit: 'mm', format: 'b3' });

                    for(var x=0; x < siteSpecific.length; x++){
                        doc.addImage(reportLogo, "PNG", 15, 0, 15, 15);

                        doc.setFontSize(14);
                        doc.setFontType("bold");

                        let design_y = 20
                        
                        doc.text(15,design_y,`Product Expiration Report`)
                        doc.setFontType("normal");
                        doc.setFontSize(10);

                        design_y = design_y + 5;
                        doc.text(15,design_y,"As Of: " + this.inputDate.format('YYYY-MM-DD'))
                        design_y = design_y + 5;
                        doc.text(15,design_y,"Status: " + ((this.inputStatus == 1) ? 'All (Expired & Near Expiry)' : (this.inputStatus == 2) ? 'Near Expiry - ' + this.daysToExpire + ' Days' : 'Expired'))

                        if(x > 0){
                            //add new page
                            doc.addPage();
                        }

                        design_y = design_y + 5;
                        doc.text(15,design_y,"Store Name: " + siteSpecific[x].report_details[0].site_code + " " + siteSpecific[x].report_details[0].site_name)

                        this.birSalesReports = siteSpecific[x].report_details

                        let grouper = ''

                        let detailColStyles = {
                            0: {cellWidth: 24},
                            1: {cellWidth: 50},
                            2: {cellWidth: 20},
                            3: {cellWidth: 25},
                            4: {cellWidth: 40}
                        } 
                        
                        let header = [
                            '', '', '', '', ''
                        ]

                        if(this.birSalesReports.length > 0){
                            let reportData = []
                            let grouper = 'start'
                            
                            let sub_qty = 0
                            let total_qty = 0
                            let item_desc = ''
                            let status = ''
                            let grouper_name = ''
                            let item_count = 0

                            for(let i=0; i < this.birSalesReports.length; i++){
                                let reportLine = this.birSalesReports[i]
                                
                                grouper_name = ((this.inputGroupBy == 's.id') ? reportLine.supplier_name : (this.inputGroupBy == 'b.id') ? reportLine.brand_name : reportLine.category_name );
                                
                                if(grouper == 'start'){
                                    grouper = grouper_name
                                    status = reportLine.lotcode_status
                                    item_desc = reportLine.product_name
                                    item_count++;
                                    // Grouping
                                    let detail_header = [{content: group_by + `: ${grouper_name}`, colSpan: 2, styles: {halign: 'left', fontStyle: 'bold'}}];
                                    reportData.push(Object.assign({}, detail_header))
                                    reportData.push(Object.assign({}, [{content: 'Product Name: ' + reportLine.product_name.toUpperCase(), colSpan: 5, styles: {halign: 'left', fontStyle: 'bold'}}]))
                                    reportData.push(Object.assign({}, [{content: 'Product Status: ' + reportLine.lotcode_status, colSpan: 2, styles: {halign: 'left', fontStyle: 'bold'}}]))
                                    reportData.push(Object.assign({}, ['', 
                                            {content: 'Lot Code', styles: {halign: 'left', fontStyle: 'bold'}},
                                            {content: 'Quantity', styles: {halign: 'center', fontStyle: 'bold'}},
                                            {content: 'Expiry Date', styles: {halign: 'center', fontStyle: 'bold'}},
                                            {content: (reportLine.lotcode_status == 'EXPIRED') ? '# of Days Expired' : '# of Days to Expiry', styles: {halign: 'center', fontStyle: 'bold'}}
                                        ]))
                                } else {

                                    if(item_desc != reportLine.product_name  || grouper != grouper_name) {
                                        reportData.push(Object.assign({}, ["rowLine"]))
                                        reportData.push(Object.assign({}, [ '',
                                            {content: 'TOTAL: ', styles: {halign: 'right', fontStyle: 'bold'}},
                                            {content: Number(sub_qty).toFixed(0), styles: {halign: 'right', fontStyle: 'bold'}}
                                        ]))
                                        sub_qty = 0
                                        if(grouper != grouper_name){
                                            let detail_header = [{content: group_by + `: ${grouper_name}`, colSpan: 2, styles: {halign: 'left', fontStyle: 'bold'}}];
                                            reportData.push(Object.assign({}, detail_header))
                                        }
                                        reportData.push(Object.assign({}, [{content: 'Product Name: ' + reportLine.product_name.toUpperCase(), colSpan: 5, styles: {halign: 'left', fontStyle: 'bold'}}]))
                                        if(this.inputStatus != 1){
                                            reportData.push(Object.assign({}, ['', 
                                                {content: 'Lot Code', styles: {halign: 'left', fontStyle: 'bold'}},
                                                {content: 'Quantity', styles: {halign: 'center', fontStyle: 'bold'}},
                                                {content: 'Expiry Date', styles: {halign: 'center', fontStyle: 'bold'}},
                                                {content: (reportLine.lotcode_status == 'EXPIRED') ? '# of Days Expired' : '# of Days to Expiry', styles: {halign: 'center', fontStyle: 'bold'}}
                                            ]))
                                        }
                                        
                                        item_count++;
                                    }

                                    if(status != reportLine.lotcode_status && item_desc == reportLine.product_name){
                                        reportData.push(Object.assign({}, ["rowLine"]))
                                        reportData.push(Object.assign({}, [ '',
                                            {content: 'TOTAL: ', styles: {halign: 'right', fontStyle: 'bold'}},
                                            {content: Number(sub_qty).toFixed(0), styles: {halign: 'right', fontStyle: 'bold'}}
                                        ]))
                                        sub_qty = 0
                                    }
                                        
                                    if(status != reportLine.lotcode_status  || grouper != grouper_name){
                                        item_count = 1
                                        reportData.push(Object.assign({}, [{content: 'Product Status: ' + reportLine.lotcode_status, colSpan: 2, styles: {halign: 'left', fontStyle: 'bold'}}]))
                                        reportData.push(Object.assign({}, ['', 
                                            {content: 'Lot Code', styles: {halign: 'left', fontStyle: 'bold'}},
                                            {content: 'Quantity', styles: {halign: 'center', fontStyle: 'bold'}},
                                            {content: 'Expiry Date', styles: {halign: 'center', fontStyle: 'bold'}},
                                            {content: (reportLine.lotcode_status == 'EXPIRED') ? '# of Days Expired' : '# of Days to Expiry', styles: {halign: 'center', fontStyle: 'bold'}}
                                        ]))
                                    }
                                }

                                //body
                                    let detail = [
                                        '',
                                        {content: reportLine.lot_code, styles: {halign: 'left'}},
                                        {content: Number(reportLine.onhand_quantity).toFixed(0), styles: {halign: 'right'}},
                                        {content: moment(reportLine.expired_at).format('MM/DD/YYYY'), styles: {halign: 'center'}},
                                        {content: Number(reportLine.expiry_days).toFixed(0), styles: {halign: 'right'}}
                                    ]

                                    sub_qty += Number(reportLine.onhand_quantity)
                                    total_qty += Number(reportLine.onhand_quantity)

                                    reportData.push(detail)

                                    

                                    grouper = grouper_name
                                    status = reportLine.lotcode_status
                                    item_desc = reportLine.product_name

                                
                                
                                
                                let total_detail = []
                                let sub_detail = []
                                if(i == this.birSalesReports.length-1){
                                
                                    sub_detail = ['',
                                        {content: 'TOTAL: ', styles: {halign: 'right', fontStyle: 'bold'}},
                                        {content: Number(sub_qty).toFixed(0), styles: {halign: 'right', fontStyle: 'bold'}}
                                    ]
                                    reportData.push(Object.assign({}, ["rowLine"]))
                                    reportData.push(sub_detail)

                                    total_detail = ['',
                                        {content: 'GRAND TOTAL: ', styles: {halign: 'right', fontStyle: 'bold'}},
                                        {content: Number(total_qty).toFixed(0), styles: {halign: 'right', fontStyle: 'bold'}}
                                    ]
                                    reportData.push(Object.assign({}, ["rowLine"]))
                                    reportData.push(total_detail)

                                    if(this.inputStatus != 1) {
                                        reportData.push(Object.assign({}, ['', {content: status + ' ITEM COUNT: ', styles: {halign: 'right', fontStyle: 'bold'}},
                                        {content: Number(item_count).toFixed(0), styles: {halign: 'right', fontStyle: 'bold'}}]))
                                    }

                                    //create table
                                    design_y = design_y
                                    doc.autoTable({
                                        startY: design_y, 
                                        head: [header],
                                        body: reportData, 
                                        theme: 'plain',
                                        tableWidth: 'wrap',
                                        headStyles: {
                                            lineWidth: 0
                                        },
                                        styles: {
                                            cellPadding: 1.0, fontSize: 9,
                                            halign: 'right'
                                        },
                                        columnStyles: detailColStyles,
                                        didParseCell: function(data) {
                                            if (data.row.section == 'body' && data.row.raw[0] == 'rowLine'){
                                                data.cell.styles.fillColor = [0, 0, 0]
                                                data.cell.styles.fontSize = 1
                                                data.cell.styles.cellPadding = 0
                                            } else if (data.row.section == 'body' && data.row.raw[6] == 'Total :'){
                                                data.cell.styles.fontStyle = 'bold'
                                            }
                                        }
                                    });
                                } else {
                                    let current_grouper = ""
                                    let next_grouper = ""

                                    current_grouper = reportLine.business_date
                                    next_grouper = this.birSalesReports[i+1].business_date

                                    if(current_grouper != next_grouper){
                                       
                                        sub_detail = ['',
                                        {content: 'Total: ', styles: {halign: 'right', fontStyle: 'bold'}},
                                        {content: this.convertToCurrency(sub_qty), styles: {halign: 'right', fontStyle: 'bold'}}
                                    ]
                                        reportData.push(Object.assign({}, ["rowLine"]))
                                        reportData.push(sub_detail)

                                        sub_qty = 0
                                    }   
                                }
                            }
                        }
                    }

                    let printed_by = secureStorage.getItem("email")
                        if(printed_by == null){
                            printed_by = ''
                        }

                    let pageCount = doc.internal.getNumberOfPages();
                    
                    for(let i = 0; i < pageCount; i++) { 
                        doc.setPage(i);
                        reportUtils.pdfTools.addFooter(doc, printed_by, "Product Expiration Report", 640, 480, i, pageCount, "right")
                    }
                    window.open(URL.createObjectURL(doc.output("blob")))
                } else {
                    this.openNotificationWithIcon('error', 'No data to export.');
                }
                this.spinning= false;
            },
            async generateExcel(){
                const workbook = new ExcelJS.Workbook();
                workbook.created = new Date();
                workbook.modified = new Date();
                const sheet = workbook.addWorksheet("Product Expiration Report", {
                    pageSetup:{paperSize: 9}
                });

                const data_starts_at_row = 8

                let reportLogo = document.getElementById('reportLogo');
            
                const base64Image = reportUtils.csvxlsxTools.getBase64Image(reportLogo)

                const imageId2 = workbook.addImage({
                    base64: base64Image,
                    extension: 'png',
                });

                sheet.addImage(imageId2, {
                    tl: { col: 0, row: 0 },
                    ext: { width: 61, height: 61 }
                });

                sheet.getRow(4).values = ["Product Expiration Report"]
                sheet.getRow(5).values = ['As Of: ' + this.inputDate.format('YYYY-MM-DD')]
                sheet.getRow(6).values = ["Status: " + ((this.inputStatus == 1) ? 'All (Expired & Near Expiry)' : (this.inputStatus == 2) ? 'Near Expiry - '+ this.daysToExpire + ' Days' : 'Expired')]

                //custom header
                sheet.getRow(data_starts_at_row).values = ["Product Name", "Lot Code", "Quantity", "Expiry Date", "Days to Expiry/Expired","Status", "Supplier", "Category", "Brand"];

                sheet.columns = [
                    { key: "product_name" , width: 20 },
                    { key: "lot_code", width: 15 },
                    { key: "onhand_quantity" , width: 20 },
                    { key: "expired_at", width: 15 },
                    { key: "expiry_days", width: 30 },
                    { key: "lotcode_status", width: 15 },
                    { key: "supplier_name", width: 15 },
                    { key: "category_name", width: 15 },
                    { key: "brand_name", width: 15 }
                ];

                var report_details = this.JsonData
                var rowDatas = []
                var horizontal_range = 0
                for(let i = 4; i < report_details.length; i++){
                    const report_detail = report_details[i]
                        if(report_detail){
                            const rowData = {product_name: report_detail["Product Name"], lot_code: report_detail["Lot Code"], onhand_quantity: report_detail["Quantity"], 
                            expired_at: report_detail["Expiry Date"], expiry_days: report_detail["Days to Expiry/Expired"], lotcode_status: report_detail["Status"], 
                            supplier_name: report_detail["Supplier"] ,category_name: report_detail["Category"], brand_name: report_detail["Brand"]}
                            rowDatas.push(rowData)
                        }
                    }

                sheet.addRows(rowDatas);

                //styles
                sheet.getRow(4).font = { bold: true, size: 12 };
                sheet.getRow(4).height = 20;
                // sheet.getRow(7).font = { bold: true };
                sheet.getRow(data_starts_at_row).font = { bold: true };

        
                sheet.eachRow(function (Row, rowNum) {
                    if(rowNum >= data_starts_at_row){
                        Row.eachCell(function (Cell, cellNum) {
                            if (rowNum == data_starts_at_row) {
                                Cell.alignment = {
                                    horizontal: 'center'
                                }
                            }
                            else{
                                Cell.alignment = {
                                    vertical: 'middle',
                                    horizontal: 'left'
                                }
                            }
                        })
                    }
                })
                
                workbook.xlsx.writeBuffer().then(function(buffer) {
                    const blob = new Blob([buffer], { type: "applicationi/xlsx" });
                    saveAs(blob, `ProductExpirationReport.xlsx`);
                });
                this.JsonData = []
            },
            generateFile: async function() {
                let as_of_date_from = this.inputDate.format('YYYY-MM-DD HH:mm:ss');
                let as_of_date_to = this.inputDate.format('YYYY-MM-DD HH:mm:ss');
                let group_by = ((this.inputGroupBy == 's.id') ? 'Supplier' : (this.inputGroupBy == 'b.id') ? 'Brand' : 'Category' );

                if([2].includes(this.inputStatus) && Number(this.daysToExpire) < 1){
                    this.openNotificationWithIcon('error', 'Days to expire is required.');
                    this.spinning= false;
                    return
                }

                if([2].includes(this.inputStatus))
                     as_of_date_to = moment(this.inputDate).add(this.daysToExpire, 'd').format('YYYY-MM-DD HH:mm:ss')
                
                var get_request = await HTTPRequest.getRequest(this.endPoint + 'product_expiration_report?site_id=' + this.inputSite + '&status=' + this.inputStatus + '&as_of_date_to=' + as_of_date_to + '&as_of_date_from=' + as_of_date_from + '&days_to_expire=' + this.daysToExpire + '&order_by=' + this.inputOrderBy + '&group_by=' + this.inputGroupBy, null);

                var siteSpecific = get_request;
                if(siteSpecific.length > 0){
                    let headers = [];
                    let site_specific = [];
                    let reportData = []
                    reportData.push(Object.assign({}, ['Product Expiration Report']))
                    reportData.push(Object.assign({}, ['As Of: ' + this.inputDate.format('YYYY-MM-DD')]))
                    reportData.push(Object.assign({}, ["Status: " + ((this.inputStatus == 1) ? 'All (Expired & Near Expiry)' : (this.inputStatus == 2) ? 'Near Expiry - '+ this.daysToExpire + ' Days' : 'Expired')]))

                    for(var x=0; x < siteSpecific.length; x++){
                        this.birSalesReports = siteSpecific[x].report_details

                        headers = ['Product Name', 'Lot Code', 'Quantity', 'Expiry Date', 'Days to Expiry/Expired', 'Status', 'Supplier', 'Category', 'Brand']
                        reportData.push(Object.assign({}, headers))
                        if(this.birSalesReports.length > 0){
                            let total_qty = 0

                            for(let i=0; i < this.birSalesReports.length; i++){
                                let reportLine = this.birSalesReports[i]
                                
                                //body
                                let detail = [
                                    reportLine.product_name,
                                    reportLine.lot_code,
                                    reportLine.onhand_quantity,
                                    moment(reportLine.expired_at).format('MM/DD/YYYY'),
                                    Number(reportLine.expiry_days),
                                    reportLine.lotcode_status,
                                    reportLine.supplier_name,
                                    reportLine.category_name,
                                    reportLine.brand_name
                                    ]
                                
                                reportData.push(detail)
                                total_qty += Number(reportLine.onhand_quantity)
                                let total_detail = []
                                if(i == this.birSalesReports.length-1){
                                    total_detail = ['', 
                                        'Total :',
                                        this.convertToCurrency(total_qty),
                                    ]
                                    reportData.push(total_detail)
                                }
                            }
                        }

                        let printed_by = secureStorage.getItem("email")
                        if(printed_by == null){
                            printed_by = ''
                        }

                        reportData.push(["Product Expiration Report", "Generate By: " + printed_by,"Generate Date: " + moment().format("MM/DD/YYYY hh:mm:ssA")])

                        let keys = headers;
                        let values = reportData;
                        var values_length = values.length;

                        let newJsonData=[];

                        // change headers and report data as key and value object
                        for(var i=0;i < values_length; i++){
                        	var result =  Object.assign.apply({}, keys.map( (val, index) => ( {
                              		[val]: values[i][index]
                            	  }
                              )
                            )
                          );
                          newJsonData.push(result)
                        }
                        // change undefined on arr
                        newJsonData.forEach(function(obj) {
                          for(var i in obj) {
                            if(obj[i] === undefined || obj[i] === null ) {
                              obj[i] = '';
                            }
                          }
                        });
                        site_specific.push(newJsonData)
                    }
                    this.JsonData = site_specific.flat(Infinity);
                } else {
                    this.openNotificationWithIcon('error', 'No Data');
                }
                this.spinning= false;
            },
            clearJsonData(){
              // console.log("working",this.JsonData)
              this.JsonData = [];
            },
        }
    };
</script>

<style></style>